import { ForwardOutlineIcon } from '@carboncopyco/icons';

export const RuleArrow = () => {
  return (
    <div className="flex items-center flex-shrink-0 text-ds-natural-600">
      <ForwardOutlineIcon size={16} />
    </div>
  );
};
